import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthToken } from "./useAuthToken";

interface GuardProps {
  children?: ReactNode;
}

export function NoRequireAuth({ children }: Readonly<GuardProps>) {
  const { isAuthenticated } = useAuthToken();

  if (isAuthenticated) {
    return <Navigate to="/profile" replace />;
  }

  return <>{children}</>;
}

export default NoRequireAuth;
